import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/index.vue'
import store from '@/store/index.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'Home',
    component: Home
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/post',
    name: 'Post',
    component: () => import(/* webpackChunkName: "post" */ '../views/Post/index.vue'),
    meta: {
      back: true
    }
  },
  {
    path: '/catalog',
    name: 'Catalog',
    component: () => import(/* webpackChunkName: "catalog" */ '../views/Catalog/index.vue')
  },
  {
    path: '/member',
    name: 'Member',
    component: () => import(/* webpackChunkName: "member" */ '../views/Member/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/page/testv',
  routes
})

const history = []
router.beforeEach((to, from, next) => {
  // console.log('beforeEach: ', store.state.action)
  if (store.state.action === 'pop') {
    history.pop()
  } else if (store.state.action === 'replace') {
    history.pop()
    history.push(from)
  } else {
    history.push(from)
  }
  store.commit('setHistory', history.slice(0))
  next()
})

export default router
